define('viewmodels/pages/cash/methods/bank/AddBankWithdrawViewModel',['knockout', 'underscore', 'common/payment/piqConstants'], function (ko, _) {

    var CreateBankWithdrawViewModel = function (formFields, WithdrawAmountStep, getWithdrawField, withdrawModel, Wizard) {

        var methodModel = withdrawModel.methodModel(),
            wizardModel;

        var labels = {
            clearingNumber: getWithdrawField('clearing_number_field_label'),
            accountNumber: getWithdrawField('account_number_field_label'),
            beneficiaryName: getWithdrawField('beneficiary_name_field_label'),
            iban: getWithdrawField('iban_field_label'),
            bic: getWithdrawField('bic_swift_field_label'),
            beneficiaryAddress: getWithdrawField('beneficiary_address_field_label'),
            bankName: getWithdrawField('bank_name_field_label'),
            branchAddress: getWithdrawField('branch_address_field_label')
        };

        this.wizardModel = wizardModel = new Wizard({
            steps: [
                {
                    fields: _.map(methodModel.getFields(), function(fieldName) {
                        return {
                            field: formFields.textField( methodModel[fieldName] ),
                            label: labels[fieldName],
                            smallInfo: null
                        };
                    }),
                    type: 'basicfields'
                },
                new WithdrawAmountStep(withdrawModel)
            ],
            onPayment: function(promise) {

                return promise.then(null, function(e) {

                    if (e.hasError('iban.invalid')) {

                        methodModel.iban.invalidate('NOT_IBAN');
                        wizardModel.stepNumber(1);

                    }
                    else if (e.hasError('bic.invalid')) {

                        methodModel.iban.invalidate('NOT_BIC_SWIFT_CODE');
                        wizardModel.stepNumber(1);

                    }
                    else {
                        throw e;
                    }

                });
            }
        });
    };

    CreateBankWithdrawViewModel.prototype.getView = function() {
        return 'views/pages/cash/methods/wizardMethod.html';
    };

    return CreateBankWithdrawViewModel;
});

